import {Button, Divider, Paper, styled, Typography} from '@mui/material'
export const MARKER_TOOLTIP_WIDTH = 320
export const MarkerContainer = styled(Paper)(() => ({
  position: 'absolute',
  padding: `16px`,
  borderRadius: `4px`,
  width: `${MARKER_TOOLTIP_WIDTH}px`,
  zIndex: 999
}))
export const StyledButton = styled(Button, {shouldForwardProp: (prop) => prop !== 'actionType'})(
  ({theme, actionType}) => ({
    height: '42px',
    textTransform: 'none',
    fontSize: theme.typography.subtitle1.fontSize,
    backgroundColor: actionType === 'add' ? theme.palette.hpPrimary : theme.palette.hpAccentRed,
    color: theme.palette.hpWhite,
    '&.Mui-disabled': {
      backgroundColor: theme.palette.hpBaseLighter,
      color: theme.palette.hpBaseDarker
    },
    ...(actionType === 'remove' && {
      '&:hover': {
        backgroundColor: theme.palette.error.dark
      }
    })
  })
)

export const StyledTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.titleMedium.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.hpAccentBlack
}))
export const CancelButton = styled(Button)(({theme}) => ({
  color: theme.palette.hpPrimaryDark,
  textTransform: 'none',
  fontSize: theme.typography.subtitle1.fontSize,
  '&:hover': {
    backgroundColor: theme.palette.hpWhite,
    textDecoration: 'underline'
  },
  '&:active': {
    border: 'none'
  },
  backgroundColor: theme.palette.hpWhite
}))

export const StyledDivider = styled(Divider)(({theme}) => ({
  marginBottom: theme.spacing(1.5),
  marginTop: theme.spacing(1),
  backgroundColor: theme.palette.hpBaseLighter
}))
